module.exports = __webpack_public_path__ + "static/media/puck3.cfcbc650.png";